import { useEffect, useState } from 'react';

/** True below MUI `md` (900px). Safe without ThemeProvider; respects setupTests matchMedia mock. */
export default function usePartnerMobileLayout() {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false;
    }
    try {
      return Boolean(window.matchMedia('(max-width: 899.95px)').matches);
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    let mq;
    try {
      mq = window.matchMedia('(max-width: 899.95px)');
    } catch {
      return undefined;
    }
    if (!mq) return undefined;

    const apply = () => setIsMobile(Boolean(mq.matches));
    apply();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
      return () => {
        if (typeof mq.removeEventListener === 'function') {
          mq.removeEventListener('change', apply);
        }
      };
    }
    if (typeof mq.addListener === 'function') {
      mq.addListener(apply);
      return () => {
        if (typeof mq.removeListener === 'function') {
          mq.removeListener(apply);
        }
      };
    }
    return undefined;
  }, []);

  return isMobile;
}
